import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import CrossPlatformLogo from "@crehana/compass.layouts/CrossPlatformLogo";
import { useIsClient } from "@crehana/react-hooks";
import { clsx } from "clsx";
import LeftMenu from "./components/LeftMenu/index.js";
import Logo from "./components/Logo/index.js";
import RightSectionWrapper from "./components/RightSectionWrapper/index.js";
import { useMainMenuContext } from "./hooks/index.js";
import Navbar from "./ui/Navbar.js";
import NavbarContainer from "./ui/NavbarContainer.js";
import SubmenuBackdrop from "./ui/SubmenuBackdrop.js";
const MainMenu = ()=>{
    const isClient = useIsClient();
    const { layoutConfig, hasIntegration, organizationSlug, renderCustomLogo } = useMainMenuContext();
    const renderLogo = ()=>{
        if (renderCustomLogo) return renderCustomLogo();
        if (hasIntegration) return /*#__PURE__*/ jsx(CrossPlatformLogo, {
            organizationSlug: organizationSlug || ''
        });
        return /*#__PURE__*/ jsx(Logo, {});
    };
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Navbar, {
                children: /*#__PURE__*/ jsxs(NavbarContainer, {
                    className: clsx('flex justify-between', 'dashboard' === layoutConfig.navType && 'max-w-full'),
                    navType: layoutConfig.navType,
                    children: [
                        /*#__PURE__*/ jsxs("div", {
                            className: clsx('flex items-center sm:flex-row-reverse', layoutConfig.newSidebarEnabled && 'w-1/2'),
                            children: [
                                isClient && /*#__PURE__*/ jsx(LeftMenu, {}),
                                renderLogo()
                            ]
                        }),
                        /*#__PURE__*/ jsx(RightSectionWrapper, {})
                    ]
                })
            }),
            /*#__PURE__*/ jsx(SubmenuBackdrop, {})
        ]
    });
};
const MainMenu_MainMenu = MainMenu;
export default MainMenu_MainMenu;
